import { render } from "./UCSearchEntityERP.vue?vue&type=template&id=54db44f2"
import script from "./UCSearchEntityERP.vue?vue&type=script&lang=js"
export * from "./UCSearchEntityERP.vue?vue&type=script&lang=js"

import "./UCSearchEntityERP.vue?vue&type=style&index=0&id=54db44f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__